import { render, staticRenderFns } from "./AddSpecimenToSaleImage.vue?vue&type=template&id=a885e7ac"
import script from "./AddSpecimenToSaleImage.vue?vue&type=script&lang=js"
export * from "./AddSpecimenToSaleImage.vue?vue&type=script&lang=js"
import style0 from "./AddSpecimenToSaleImage.vue?vue&type=style&index=0&id=a885e7ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports